<template>
  <div v-show="show" class="progressUpdate-container">
      <div class="bg"></div>
      <div class="progressUpdate-edit">
        <div class="title">
          <div class="left">进展更新</div>
          <div @click="close" class="close"></div>
        </div>
        <div class="tips">
          <i></i>
          <span>{{title}}</span>
        </div>
        <div ref="listP" class="list">
          <ul ref="listDom">
            <li v-for="item in list" :key="item.id">
              <div class="left">
                <div class="t">{{item.content}}</div>
                <div class="b">
                  <span>由<i> {{ item.user_name }} </i>更新</span>
                  <span>{{item.publish_time}}</span>
                </div>
              </div>
              <div class="right">
                <i @click="editId = item.id;editContent = item.content;showEdit = true;" v-show="item.can_edit_delete" class="edit"></i>
                <i @click="del(item.id)" v-show="item.can_edit_delete" class="del"></i>
              </div>
            </li>
          </ul>
        </div>
        
        <div class="textarea">
          <textarea v-model="text" placeholder="请填写进展更新" maxlength="50"></textarea>
          <div class="btns">
            <div class="num">{{text.length}}/50</div>
            <div @click="save" class="btn">提交</div>
          </div>
        </div>
      </div>

      <div v-show="showEdit" class="editContent">
        <div class="box">
          <div class="title">
            <div class="left">编辑</div>
            <div @click="showEdit = false;" class="close"></div>
          </div>
          <div class="content">
            <textarea v-model="editContent" maxlength="50"></textarea>
            <div class="num">{{editContent.length}}/50</div>
          </div>
          <div class="btns">
            <div @click="edit" class="btn g">保存</div>
            <div @click="showEdit = false;" class="btn">取消</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import vClickOutside from "v-click-outside";

export default {
  name: 'confirm',
  directives: {
      clickOutside: vClickOutside.directive
  },
  data() {
    return {
      showEdit: false,
      editId: '',
      editContent: '',
      foreman_view: '',
      text: '',
      list: [],
      show: true,
      showSelect: false,
      id: '',
      r: null,
      title: ''
    }
  },
  methods: {
    scrollToBottom(){
      console.log(this.$refs.listDom.scrollHeight)
      this.$refs.listP.scrollTo({
          top: this.$refs.listDom.scrollHeight,
          behavior: 'smooth' // Enable smooth scrolling
      })
    },
    getList() {
      let info = {
        topic_id: this.id
      }
      common.myFetch(apis.newTopicListProgress,info).then(res => {
        this.list = res.list

        this.$nextTick(() => { 
          this.scrollToBottom()
        })
        
      })
    },
    open(c, r) {
      this.id = c.id;
      this.title = c.title;
      this.getList()
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
      this.r(true)
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle()
      this.r(true)
      this.close()
    },
    beta() {
      this.config.beta.handle()
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    },
    save() {
      let info = {
        topic_id: this.id,
        content: this.text
      }
      common.myFetch(apis.newTopicReleaseProgress,info).then(res => {
        if(res){
          this.$toast(res);
          this.text = ''
          this.getList()
        }
      })
    },
    edit() {
      let info = {
        topic_id: this.id,
        content: this.editContent,
        id: this.editId
      }
      common.myFetch(apis.newTopicReleaseProgress,info).then(res => {
        if(res){
          this.$toast(res);
          this.editContent = ''
          this.editId = ''
          this.showEdit = false;
          this.getList()
        }
      })
    },
    del(id) {
      let info = {
        topic_id: this.id,
        id: id
      }
      common.myFetch(apis.newTopicDeleteProgress,info).then(res => {
        if(res){
          this.$toast(res);
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .progressUpdate-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;

    .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);
    }

    .progressUpdate-edit {
      display: flex;
      flex-direction: column;
      width: 800px;
      height: 644px;
      background: #F9F9F9;
      box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
      border-radius: 4px;
      padding: 20px 30px;
      box-sizing: border-box;

      .title {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 16px;

        .left {
          font-weight: bold;
          font-size: 24px;
          color: #050F0F;
          line-height: 33px;
        }
        
        .close {
          display: block;
          width: 16px;
          height: 16px;
          background: url('../../assets/img/common/close.svg') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
        }
      }

      .tips {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 54px;
        background: rgba(65,180,140,0.1);
        border-radius: 12px;
        border: 1px solid #41B48C;
        box-sizing: border-box;
        padding: 10px 20px;
        margin-bottom: 14px;

        i {
          min-width: 24px;
          height: 24px;
          margin-right: 10px;
          background: url('./assets/xt.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
        }

        span {
          font-weight: 400;
          font-size: 16px;
          color: #050F0F;
          line-height: 22px;
        }
      }

      .list {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        min-height: 0;
        padding: 14px 0;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(185,195,195,0.5);
          border-radius: 2px;
        }

        ul {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        li {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 14px 0;
          box-sizing: border-box;

          .left {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0;
            .t {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 400;
              font-size: 16px;
              color: #050F0F;
              line-height: 22px;
              margin-bottom: 12px;
            }

            .b {
              display: flex;
              align-items: center;

              span {
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 13px;
                color: #B9C3C3;
                line-height: 18px;
                margin-right: 12px;

                i {
                  color: #41B48C;
                  margin: 0 5px;
                }
              }
            }
          }

          .right {
            display: flex;
            align-items: center;

            .edit {
              width: 24px;
              height: 24px;
              background: url('./assets/edit.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 20px;
              user-select: none;
              cursor: pointer;
            }

            .del {
              width: 24px;
              height: 24px;
              background: url('./assets/del.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 20px;
              user-select: none;
              cursor: pointer;
            }
          }
        }
      }

      .textarea {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 120px;
        background: rgba(185,195,195,0.2);
        border-radius: 4px;
        padding: 10px 14px;
        box-sizing: border-box;

        textarea {
          width: 100%;
          flex: 1;
          min-height: 0;
          background: transparent;
          border: none;
          outline: none;
          resize: none;
          font-size: 14px;
          color: #333;
        }

        .btns {
          display: flex;
          align-items: end;
          justify-content: flex-end;

          .num {
            font-weight: 500;
            font-size: 12px;
            color: #829191;
            margin-right: 10px;
          }

          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 68px;
            height: 32px;
            background: #41B48C;
            border-radius: 4px;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            user-select: none;
            cursor: pointer;
          }
        }
      }
    }

    .editContent {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99999;
      width: 100vw;
      height: 100vh;
      background: rgba(50,59,75,0.3);
      border-radius: 2px;
      backdrop-filter: blur(1.6px);

      .box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        width: 498px;
        height: 294px;
        background: #F9F9F9;
        box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
        border-radius: 4px;
        padding: 20px 30px 24px;
        box-sizing: border-box;

        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-bottom: 20px;

          .left {
            font-weight: 400;
            font-size: 24px;
            color: #050F0F;
            line-height: 34px;
          }

          .close {
            display: block;
            width: 18px;
            height: 18px;
            background: url('../../assets/img/common/close.svg') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            user-select: none;
            cursor: pointer;
          }
        }

        .content {
          position: relative;
          width: 100%;
          height: 140px;
          background: rgba(185,195,195,0.2);
          border-radius: 4px;
          padding: 10px 20px;
          box-sizing: border-box;
          margin-bottom: 24px;

          textarea {
            width: 100%;
            height: 100%;
            background: transparent;
            border: none;
            outline: none;
            resize: none;
            font-weight: 500;
            font-size: 16px;
            color: #050F0F;
          }

          .num {
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-weight: 500;
            font-size: 12px;
            color: #829191;
          }
        }

        .btns {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;

          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 32px;
            background: #B9C3C3;
            border-radius: 4px;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            user-select: none;
            cursor: pointer;

            &.g {
              background: #41B48C;
              margin-right: 20px;
            }
          }
        }
      }
    }
}
</style>
